// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as FoundersRouteImport } from './routes/founders'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlayPinRouteImport } from './routes/play.$pin'
import { Route as JoinPinRouteImport } from './routes/join.$pin'
import { Route as AuthenticatedSuperadminRouteImport } from './routes/_authenticated/superadmin'
import { Route as AuthenticatedQuotaRouteImport } from './routes/_authenticated/quota'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedResultsSessionIdRouteImport } from './routes/_authenticated/results.$sessionId'
import { Route as AuthenticatedQuizzesNewRouteImport } from './routes/_authenticated/quizzes.new'
import { Route as AuthenticatedQuizzesAnalyticsRouteImport } from './routes/_authenticated/quizzes.analytics'
import { Route as AuthenticatedHostSessionIdRouteImport } from './routes/_authenticated/host.$sessionId'
import { Route as AuthenticatedQuizzesIdEditRouteImport } from './routes/_authenticated/quizzes.$id.edit'
import { Route as AuthenticatedQuizzesIdAnalyticsRouteImport } from './routes/_authenticated/quizzes.$id.analytics'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const FoundersRoute = FoundersRouteImport.update({
            id: '/founders',path: '/founders',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AcceptableUseRoute = AcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PlayPinRoute = PlayPinRouteImport.update({
            id: '/play/$pin',path: '/play/$pin',getParentRoute: () => rootRouteImport
          })
const JoinPinRoute = JoinPinRouteImport.update({
            id: '/join/$pin',path: '/join/$pin',getParentRoute: () => rootRouteImport
          })
const AuthenticatedSuperadminRoute = AuthenticatedSuperadminRouteImport.update({
            id: '/superadmin',path: '/superadmin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuotaRoute = AuthenticatedQuotaRouteImport.update({
            id: '/quota',path: '/quota',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedResultsSessionIdRoute = AuthenticatedResultsSessionIdRouteImport.update({
            id: '/results/$sessionId',path: '/results/$sessionId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuizzesNewRoute = AuthenticatedQuizzesNewRouteImport.update({
            id: '/quizzes/new',path: '/quizzes/new',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuizzesAnalyticsRoute = AuthenticatedQuizzesAnalyticsRouteImport.update({
            id: '/quizzes/analytics',path: '/quizzes/analytics',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHostSessionIdRoute = AuthenticatedHostSessionIdRouteImport.update({
            id: '/host/$sessionId',path: '/host/$sessionId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuizzesIdEditRoute = AuthenticatedQuizzesIdEditRouteImport.update({
            id: '/quizzes/$id/edit',path: '/quizzes/$id/edit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuizzesIdAnalyticsRoute = AuthenticatedQuizzesIdAnalyticsRouteImport.update({
            id: '/quizzes/$id/analytics',path: '/quizzes/$id/analytics',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedQuotaRoute: AuthenticatedQuotaRoute,AuthenticatedSuperadminRoute: AuthenticatedSuperadminRoute,AuthenticatedHostSessionIdRoute: AuthenticatedHostSessionIdRoute,AuthenticatedQuizzesAnalyticsRoute: AuthenticatedQuizzesAnalyticsRoute,AuthenticatedQuizzesNewRoute: AuthenticatedQuizzesNewRoute,AuthenticatedResultsSessionIdRoute: AuthenticatedResultsSessionIdRoute,AuthenticatedQuizzesIdAnalyticsRoute: AuthenticatedQuizzesIdAnalyticsRoute,AuthenticatedQuizzesIdEditRoute: AuthenticatedQuizzesIdEditRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AcceptableUseRoute: AcceptableUseRoute,AuthRoute: AuthRoute,FoundersRoute: FoundersRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,JoinPinRoute: JoinPinRoute,PlayPinRoute: PlayPinRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)